import { useTranslation } from "react-i18next";

const Email = ({ emailIsValid, setEmail, email, label, required,...props }) => {
  const { t } = useTranslation();

  return (
    <div className="form-group">
      <label>
        {label}
        {required && <span>*</span>}
      </label>
      <input
        type="email"
        value={email}
        onChange={(evt) => {
          setEmail(evt.target.value);
        }}
        {...props}
      />
      {!emailIsValid && (
        <div className="valid-message">{t("auth.email.validMessage")}</div>
      )}
    </div>
  );
};

export default Email;
